import { useState } from "react";

const NAV = [
  { label: "本期封面", href: "#top" },
  { label: "事件查询", href: "#events" },
  { label: "人物专题", href: "#people" },
  { label: "现场热议", href: "#hot" },
  { label: "全网热搜", href: "#trend" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#f7f3eb]/92 backdrop-blur border-b border-[#dcd4c6]">
      {/* top utility strip */}
      <div className="border-b border-[#e5ded2]">
        <div className="mx-auto flex h-8 max-w-7xl items-center justify-between px-4 md:px-6 text-[11px] tracking-wide text-stone-500">
          <div className="flex items-center gap-2">
            <i className="ri-sun-line w-4 h-4 flex items-center justify-center"></i>
            <span>吃瓜情报杂志 · 今日刊 2026.09.05</span>
          </div>
          <div className="hidden items-center gap-4 sm:flex">
            <span className="flex items-center gap-1">
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center text-red-700"></i>
              今日 128 条新爆料
            </span>
            <span className="text-stone-300">|</span>
            <a href="#search" className="whitespace-nowrap hover:text-red-700 transition-colors">
              关键词搜索
            </a>
            <a href="#hot" className="whitespace-nowrap hover:text-red-700 transition-colors">
              登录
            </a>
          </div>
        </div>
      </div>

      {/* main bar */}
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-red-700 font-serif-sc text-xl font-black text-[#f7f3eb]">
            曝
          </span>
          <span className="flex flex-col leading-none">
            <h1 className="font-serif-sc text-2xl font-black tracking-tight text-stone-900">
              网曝网
            </h1>
            <span className="mt-0.5 text-[9px] tracking-[0.32em] text-red-700 uppercase">
              Gossip Ledger
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap text-sm font-medium text-stone-700 transition-colors hover:text-red-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#search"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-[#dcd4c6] text-stone-600 transition-colors hover:border-red-700 hover:text-red-700"
            aria-label="搜索"
          >
            <i className="ri-search-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="#subscribe"
            className="whitespace-nowrap rounded-md bg-red-700 px-4 py-2 text-sm font-medium text-[#f7f3eb] transition-colors hover:bg-red-800"
          >
            订阅快讯
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-[#dcd4c6] text-stone-700 md:hidden"
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} w-5 h-5 flex items-center justify-center`}></i>
        </button>
      </div>

      {/* mobile panel */}
      {open && (
        <div className="border-t border-[#e5ded2] bg-[#f7f3eb] px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-stone-700 hover:bg-red-700/5 hover:text-red-700"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}